import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request";

type ReplayWebhookParams = {
	returnRequestId: string;
	action: string;
};

export default function useReplayWebhook(shopId: string) {
	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/webhooks/replay-webhook",
	);

	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateReturnRequest = useInvalidateReturnRequest();

	return useMutation({
		onSuccess: (_, variables) => {
			successNotification();
			invalidateReturnRequest({
				shopId,
				returnRequestId: variables.returnRequestId,
			});
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async ({ returnRequestId, action }: ReplayWebhookParams) => {
			return mutation.mutateAsync({
				params: { path: { shopId } },
				body: {
					returnRequestId,
					action,
				},
			});
		},
	});
}
